import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

export const DetailContainer = styled.div`
  margin-top: ${tokens.spacer.x2};
`;
